export enum ReadExportMode {
    None = 'none',
    ReadOnly = 'read-only',
    ReadExportOnly = 'read-export-only'
}
